import { request } from "../helpers/axios.new";

export const GET_CLAIM_ITEMS = (workspaceId) => {
  return request({
    url: `/claims/qa${workspaceId ? `?workspaceId=${workspaceId}` : ""}`,
  });
};

export const GET_CLAIMED_REVIEWS = () => {
  return request({
    url: `/claims/claimed`,
  });
};

export const PUT_CLAIM = (itemId, claimId, claimType) => {
  return request({
    method: "PUT",
    url: `/claims/${itemId}`,
    data: { claimId, type: claimType },
  });
};

export const ASSIGN_CLAIM = ({ claimId, userId, groupId, companyId }) => {
  return request({
    url: `/claims/reassignClaim`,
    method: "PATCH",
    data: { claimId, userId, groupId, companyId },
  });
};

export const UNASSIGN_CLAIM = ({ claimId, groupId, companyId }) => {
  return request({
    url: `/claims/unassignClaim`,
    method: "PATCH",
    data: { claimId, groupId, companyId },
  });
};

export const SET_CLAIMABLE = ({ reviewId, claimable }) => {
  return request({
    url: `/claims/${reviewId}/claimable`,
    method: "PATCH",
    data: { claimable },
  });
};
